"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
class Radio extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "changeHandler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (item) => {
                this.props.onChange && this.props.onChange(item);
            }
        });
    }
    render() {
        const { field, title, options, defaultCheckedId, disabled, direction } = this.props;
        return (react_1.default.createElement("div", { className: `radio ${disabled ? 'disabled' : ''} ${direction ? direction : ''}` },
            title && react_1.default.createElement("div", { className: 'radio__title' }, title),
            options.map((item) => (react_1.default.createElement("div", { key: item.value, className: 'radio__item' },
                react_1.default.createElement("div", { className: 'radio__item-title' },
                    react_1.default.createElement("input", { className: 'radio__input', type: "radio", id: item.id.toString(), name: field && field.name, value: '', onChange: () => {
                            this.changeHandler(item);
                        }, defaultChecked: !!(defaultCheckedId && defaultCheckedId === item.id) }),
                    react_1.default.createElement("label", { htmlFor: item.id.toString(), className: 'radio__label' }, item.label)),
                item.description ? react_1.default.createElement("p", { className: 'radio__item-description' }, item.description) : null)))));
    }
}
exports.default = Radio;
